import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { MaterialModule } from '../material-module';
import { AccountsTableColumnsComponent } from './accounts-table/accounts-table-columns/accounts-table-columns.component';
import { InventoryTableColumnsComponent } from './inventory-table/inventory-table-columns/inventory-table-columns.component';
import { PaymentsTableColumnsComponent } from './payments-table/payments-table-columns/payments-table-columns.component';
import { PurchasesTableColumnsComponent } from './purchases-table/purchases-table-columns/purchases-table-columns.component';
import { PurchasingAccountTableColumnsComponent } from './purchasing-accounts-table/purchasing-account-table-columns/purchasing-account-table-columns.component';
import { SalesTableColumnsComponent } from './sales-table/sales-table-columns/sales-table-columns.component';

@NgModule({
  declarations: [
    InventoryTableColumnsComponent,
    SalesTableColumnsComponent,
    PurchasesTableColumnsComponent,
    PurchasingAccountTableColumnsComponent,
    PaymentsTableColumnsComponent,
    AccountsTableColumnsComponent,
  ],
  imports: [CommonModule, ReactiveFormsModule, MaterialModule],
})
export class TablesModule {}
